'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Logger = function () {
  function Logger() {
    var _this = this;

    _classCallCheck(this, Logger);

    this.handler = function (msg, context) {
      console.log(_this.formatter(msg, context));
    };

    this.formatter = function (msg, context) {
      var label = levelLabel(context.level);
      var wsCnt = 5 - label.length;
      var ws = " ".repeat(wsCnt);
      var result = ['' + ws + label];
      result.push('[' + new Date().toUTCString() + ']');
      result.push(msg);
      return result.join(' - ');
    };
  }

  _createClass(Logger, [{
    key: 'log',
    value: function log(msg, context) {
      if (context.level <= this.level && this.level > Manson.OFF) {
        this.handler(msg, context);
      }
    }
  }]);

  return Logger;
}();

var logger = new Logger();

var Manson = function () {
  function Manson() {
    _classCallCheck(this, Manson);
  }

  _createClass(Manson, null, [{
    key: 'labelFor',
    value: function labelFor(level) {
      return levelLabel(level);
    }
  }, {
    key: 'debug',
    value: function debug(msg) {
      logger.log(msg, { level: Manson.DEBUG });
    }
  }, {
    key: 'info',
    value: function info(msg) {
      logger.log(msg, { level: Manson.INFO });
    }
  }, {
    key: 'warn',
    value: function warn(msg) {
      logger.log(msg, { level: Manson.WARN });
    }
  }, {
    key: 'error',
    value: function error(msg) {
      logger.log(msg, { level: Manson.ERROR });
    }
  }, {
    key: 'trace',
    value: function trace(msg) {
      logger.log(msg, { level: Manson.TRACE });
    }
  }, {
    key: 'setup',
    value: function setup(config) {
      logger = new Logger();
      var c = config || {};
      logger.level = c.level || this.DEBUG;
    }
  }, {
    key: 'OFF',
    get: function get() {
      return -1;
    }
  }, {
    key: 'DEBUG',
    get: function get() {
      return 0;
    }
  }, {
    key: 'INFO',
    get: function get() {
      return 1;
    }
  }, {
    key: 'WARN',
    get: function get() {
      return 2;
    }
  }, {
    key: 'ERROR',
    get: function get() {
      return 3;
    }
  }, {
    key: 'TRACE',
    get: function get() {
      return 4;
    }
  }, {
    key: 'level',
    get: function get() {
      return logger.level;
    },
    set: function set(val) {
      logger.level = val;
    }
  }, {
    key: 'handler',
    set: function set(val) {
      logger.handler = val;
    }
  }]);

  return Manson;
}();

var levelLabel = function levelLabel(levelNumber) {
  switch (levelNumber) {
    case -1:
      return 'OFF';
    case 0:
      return 'DEBUG';
    case 1:
      return 'INFO';
    case 2:
      return 'WARN';
    case 3:
      return 'ERROR';
    case 4:
      return 'TRACE';
    default:
      return 'UNKNOWN';
  }
};

exports.default = Manson;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/manson/distribution/manson.js
// module id = 71
// module chunks = 0